import React from "react";
import {connect} from "react-redux";


class SideBar extends React.Component {


    state = {
        opened: [],
    };


    openAccordian = (id) => {

       const section = document.getElementById('section-'+id);
       if(section.classList.contains('active')){
           section.classList.remove('active')
       }else {
           section.classList.add('active')
       }
        this.changePage(id);
    }

    changePage = (id) => {
        this.props.selectPage(null, id, null, null)
    }

    render() {
        const {standards} = this.props;
        const {introduction} = this.props;

        return (
          <div className="col-md-4" >
              <ul className="soc__menu">
                  {introduction.map((introName, introIndex) => {
                          return <li className="rob-introduction"  onClick={() => this.props.selectPage(introName.id, null, null, null)}  key={introIndex}>{introName.title} </li>
                  }, this)
                  }
                  {standards.map((name, index) => {
                      return <li  key={index} {...name} data-accordion="container">
                                  <div className="rob-section"
                                       onClick={() => this.openAccordian(name.id)}> {name.title}</div>
                                  <ul id={"section-"+name.id} className={'submenu'}>
                                      {name.clusters.map(function (clusters, clustersIndex) {
                                          return <li key={clustersIndex}>
                                              <div className={"rob-cluster"}>{clusters.name}</div>
                                              <ul>
                                                  {clusters.standards.map(function (standards, standardsIndex) {
                                                      return <li className="rob-standard"  onClick={() => this.props.selectPage(null, name.id, clusters.id, standards.id)}  key={standardsIndex}>{standards.title} </li>
                                                  }, this)
                                                  }
                                              </ul>
                                          </li>
                                      }, this)
                                      }
                                  </ul>
                              </li>
                  }, this)
                  }
              </ul>
          </div>
        )
    };

};

function mapStateToProps(state) {

    return {
        standards: state.standards.section,
        introduction: state.standards.introductions,
    };
}


export default connect(mapStateToProps, {})(SideBar);


// WEBPACK FOOTER //
// ./src/components/elements/standardsOfCare/SideBar.js